import {
  QueryParameters as SearchQueryParameters,
  route as searchRoute,
} from "@faire/web-api/routes/search";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { Storage } from "@faire/web/common/Storage";
import pick from "lodash/pick";
import { useLocation } from "react-router-dom";

import { getSettingWithoutAssignmentSavedSearchFilters } from "@faire/retailer/settings/getSettingSavedSearchFilters";

const SAVED_FILTERS = "IF-SAVED-FILTERS";

export const addSavedFiltersToLink = (link: string) => {
  const savedFilters = getSavedFilters() ?? {};
  if (Object.keys(savedFilters).length === 0) {
    return link;
  }

  const parts = link.split(/\?/);
  const params = new URLSearchParams(parts[1] ?? {});
  Object.keys(savedFilters).forEach((key) => {
    params.append(key, savedFilters[key] as string);
  });
  return `${parts[0]}?${params.toString()}`;
};

export const useIsSearchPage = () => {
  const location = useLocation();
  return pathMatchesRoute(location, searchRoute);
};

export const getSavedFilters = (): Record<string, unknown> | undefined => {
  if (!getSettingWithoutAssignmentSavedSearchFilters()) {
    return undefined;
  }

  try {
    const filterString = Storage.local.getItem(SAVED_FILTERS);
    if (filterString) {
      return JSON.parse(filterString);
    }
  } catch (_) {
    /* silence */
  }
  return undefined;
};

export const hasSavedFilters = () => {
  const savedFilters = getSavedFilters();
  return savedFilters !== undefined && Object.keys(savedFilters).length > 0;
};

export const updateSavedFilters = (queryParams?: SearchQueryParameters) => {
  if (!queryParams) {
    Storage.local.removeItem(SAVED_FILTERS);
  } else {
    const filtersToSave = pick(queryParams, "category", "filter", "filters");
    Storage.local.setItem(SAVED_FILTERS, JSON.stringify(filtersToSave));
  }

  return getSavedFilters();
};

export const possiblyUpdateSavedFilters = (queryString: string) => {
  if (!Storage.local.getItem(SAVED_FILTERS)) {
    return;
  }
  const queryParams = SearchQueryParameters.parse(queryString);
  updateSavedFilters(queryParams);
};
